module.exports = __webpack_public_path__ + "static/media/bekijk.cebef068.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bekijk.svg
// module id = 932
// module chunks = 0